/** @prettier */

/**
 * グループレイアウト画像の削除ダイアログ
 */

import {Dialog, DialogTitle, DialogContent, DialogActions} from '@mui/material';
import {useState} from 'react';
import {useParams} from 'react-router-dom';

//MTH component import
import APIErrorMessage from '../APIErrorMessage';
//API import
import {
  deleteCompositionsLayoutImage,
  getCompositionsLayoutImage,
} from '../../API/API_Collection';
//Style import
import '../../css/common/common.css';
import {useTranslation} from 'react-i18next';
import {PrimaryButton, SecondaryButton} from '../BasicButton';

const ImageDeleteDialog = (props: {
  setLayoutImage: React.Dispatch<React.SetStateAction<string | null>>;
  isOpenDialog: boolean;
  setIsOpenDialog: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  //パスパラメータ取得
  const {siteID, groupID} = useParams();

  const [isOpenErrorDialog, setIsOpenErrorDialog] = useState(false); //APIエラー時のエラーダイアログ表示フラグ
  const [apiWait, setAPIWait] = useState(false); //API応答待ちフラグ

  const trans = useTranslation().t; //翻訳関数

  /**
   * OKボタン押下時処理
   */
  const deleteImage = () => {
    //パスパラメータを取得できない場合
    if (siteID === undefined || groupID === undefined) {
      return;
    }

    setAPIWait(true);

    //画像削除
    deleteCompositionsLayoutImage(siteID, groupID)
      .then(() => {
        //画像取得
        return getCompositionsLayoutImage(siteID, groupID);
      })
      .then(response => {
        props.setLayoutImage(response['layout-image']);
        handleClose();
      })
      .catch(() => {
        setIsOpenErrorDialog(true);
      })
      .finally(() => {
        setAPIWait(false);
      });
  };
  /**
   * CANCELボタン押下時処理
   */
  const handleClose = () => {
    props.setIsOpenDialog(false);
  };

  return (
    <>
      <Dialog
        open={props.isOpenDialog}
        onClose={handleClose}
        aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">
          {trans('ImageDeleteDialog.dialogBox.title')}
        </DialogTitle>
        {/* ダイアログに表示するメッセージ */}
        <DialogContent>
          {trans('ImageDeleteDialog.dialogBox.msg')}
        </DialogContent>
        <DialogActions>
          <SecondaryButton
            onClick={handleClose}
            buttonText={trans('ImageDeleteDialog.dialogBox.buttonTxt.cancel')}
            id="mv-LayoutImageUploadCancelBtn"
          />
          <PrimaryButton
            onClick={deleteImage}
            buttonText={trans('ImageDeleteDialog.dialogBox.buttonTxt.ok')}
            id="mv-LayoutImageUploadBtn"
            apiWait={apiWait}
          />
        </DialogActions>
      </Dialog>
      <APIErrorMessage
        open={isOpenErrorDialog}
        setOpen={setIsOpenErrorDialog}
        id={'mv-imageUploadErrDlgBtn'}
      />
    </>
  );
};
export default ImageDeleteDialog;
